
import { Component, Vue, Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import StepsEnterprise from '../StepsEnterprise.vue'
import http from '@/utils/request'
import '../register.scss'
import Loading from '../Loading.vue'
import { sleep } from '@/utils'
import { AddressItem } from '../register.interface'
import i18n from '@/lang'

@Component({
  components: { StepsEnterprise, Loading }
})
export default class Platform extends Vue {
  private validatePostcode = (rule: any, value: string, callback: Function) => {
    if (!value || value.length !== 6) {
      callback(new Error(i18n.t('Incorrect postal code') as string))
    } else {
      callback()
    }
  }

  private registerFormRef!: ElForm
  private submitLoading = false
  private submitDisabled = true
  private showLoading = false
  private loadingStatus = ''

  private provinceOptions: AddressItem[] = []
  private cityOptions: AddressItem[] = []
  private legalEntityTypes: string[] = ['ktp', 'passport', 'npwp']

  private form = {
    legalEntityName: '',
    legalEntityType: '',
    legalEntityId: '',
    realname: '',
    province: '',
    city: '',
    address: '',
    postcode: ''
  }

  testForm() {
    this.form = {
      legalEntityName: 'gdfgdg',
      legalEntityType: 'ktp',
      legalEntityId: '234234234',
      realname: 'sdfsdf',
      province: '',
      city: '',
      address: '123123',
      postcode: '123321'
    }
  }

  private rules = {
    postcode: [{ validator: this.validatePostcode, trigger: 'blur' }]
  }

  @Watch('form', { deep: true })
  onFormChange() {
    // eslint-disable-next-line
    const { ...params } = this.form
    const valid = Object.values(params).every(
      (value) => value !== '' && value !== undefined && value !== null
    )
    this.submitDisabled = !valid
  }

  async onSubmit() {
    try {
      await this.registerFormRef.validate()

      this.submitLoading = true
      this.showLoading = true

      const params = { ...this.form }

      params.city = this.findAddresName(this.cityOptions, this.form.city)
      params.province = this.findAddresName(this.provinceOptions, this.form.province)

      await sleep(500)

      const data = await http.post('/lend/api/updateLendInfo', params)
      if (data) {
        this.loadingStatus = 'success'
        await sleep(1500)
        // After successful registration, log in
        await this.$router.push({ path: '/register/success' })
      } else {
        this.$notify.error({ title: i18n.t('Registration failed') as string, message: '' })
      }
    } catch (e) {
      // handle error
    } finally {
      this.submitLoading = false
      this.showLoading = false
    }
  }

  async getAddressData() {
    this.provinceOptions = await this.getRegion('ID')
    if (this.form.province) {
      this.form.province = this.findAddresCode(this.provinceOptions, this.form.province)

      this.cityOptions = await this.getRegion(this.form.province)
      if (this.form.city) {
        this.form.city = this.findAddresCode(this.cityOptions, this.form.city)
      }
    }
  }

  async getProvince() {
    const result = await this.getRegion('ID')
    this.provinceOptions = result
    this.cityOptions = []
    this.form.province = ''
    this.form.city = ''
  }

  async getCity(code: string) {
    const result = await this.getRegion(code)
    this.cityOptions = result
    this.form.city = ''
  }

  async getRegion(addressNo: string) {
    const data: AddressItem[] = await http.post('/user/queryRegion', { addressNo })
    return Promise.resolve(data)
  }

  findAddresName(items: AddressItem[], code: string) {
    const result = items.find((item) => item.code === code)
    return result ? result.name : ''
  }

  findAddresCode(items: AddressItem[], name: string) {
    const result = items.find((item) => item.name === name)
    return result ? result.code : ''
  }

  mounted() {
    this.getAddressData()
    this.registerFormRef = this.$refs.registerFormRef as ElForm
    if (process.env.NODE_ENV === 'development') {
      this.testForm()
    }
  }
}
